import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import Link from '../components/general/Link';
import AllClientsPage from '../pages/AllClientsPage';
import RetainerClientLayout from './RetainerClientLayout';
import NewRetainerClientForm from '../forms/NewRetainerClientForm';

const RetainerLayout = ({ match }) => (
  <div>
    <div className="moduleNavBar">
      <Link to={`${match.url}/clients`}>
        <h4 className="moduleNavBarItem">CLIENTS</h4>
      </Link>
    </div>

    <div style={{ padding: 20 }}>
      <Switch>
        <Route path={`${match.path}/clients/create`} component={NewRetainerClientForm} />
        <Route path={`${match.path}/clients/:clientId`} component={RetainerClientLayout} />
        <Route path={`${match.path}/clients`} component={AllClientsPage} />
        <Route render={() => <Redirect to={`${match.path}/clients`} />} />
      </Switch>
    </div>
  </div>
);

RetainerLayout.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default RetainerLayout;



// WEBPACK FOOTER //
// ./src/layouts/RetainerLayout.jsx